import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import { MdExitToApp, MdPerson } from "react-icons/md";
import { Link } from "react-router-dom";
import { Input } from "../../styles/CommonStyles";
import { GetCurrentUser } from "../../services/servicesGetCurrentUser";
import { IsAdmin } from "../../services/servicesIsAdmin";
import { logout } from "../../services/servicesLogout";
import Toastify from "../../components/Toastify";
import Tooltip from "../tooltip/Tooltip";
import {
    Container,
    ContainerHeader,
    ContainerIconSoftware,
    ContainerBtnPerfilConfig,
    IconMdArrowDropDown,
    ContainerBtnsHeadSide,
    SubMenu,
    SubMenuLi,
    IconMdNotifications,
    IconMdShare,
    IconMdBorderColor,
    IconMdSearch,
    DivBusca,
    IconMdAssignment,
    MeusPosts,
    IconMdPeople,
    IconMdAddBox,
    IconIoIosArrowForward,
    IconIoIosArrowBack,
    IconIoMdHelpCircle,
    ImgHelper,
    IconCgWebsite,
} from "./styles";
import Popup from "reactjs-popup";

const Menu = () => {
    const tutorialHome = [
        require("../../assets/images/tutorial/home1.png").default,
        require("../../assets/images/tutorial/home2.png").default,
    ];
    const tutorialPostEdit = [
        require("../../assets/images/tutorial/postedit1.png").default,
        require("../../assets/images/tutorial/postedit4.png").default,
        require("../../assets/images/tutorial/postedit2.png").default,
        require("../../assets/images/tutorial/postedit3.png").default,
        require("../../assets/images/tutorial/postedit5.png").default,
    ];
    const [popupTutorial, setPopupTutorial] = useState(false);
    const [positionTutorial, setPositionTutorial] = useState(0);
    const [contentTutorial, setContentTutorial] = useState([]);

    const history = useHistory();
    const location = useLocation();
    const [subMenuUserIsOpen, setSubMenuUserIsOpen] = useState(false);

    const [busca, setBusca] = useState("");
    const [nomePerfil, setNomePerfil] = useState("");
    const [admin, setAdmin] = useState("");

    const logoSocial =
        require("../../assets/images/icone_medxsocial.jpg").default;

    function openPopupHelper() {
        if (
            window.location.pathname.includes("categoria") ||
            window.location.pathname.includes("busca") ||
            window.location.pathname.includes("myposts") ||
            window.location.pathname.includes("profile") ||
            window.location.pathname.includes("newPost")
        ) {
            Toastify.info("Em desenvolvimento");
            return 0;
        } else {
            if (window.location.href.includes("postedit")) {
                setContentTutorial(tutorialPostEdit);
                setPopupTutorial(true);
            } else if (
                window.location.pathname === "/app/" ||
                window.location.pathname === "/app/home" ||
                window.location.pathname.split("/").length === 3
            ) {
                setContentTutorial(tutorialHome);
                setPopupTutorial(true);
            }
        }
    }
    function closePopupHelper() {
        setPositionTutorial(0);
        setPopupTutorial(false);
    }
    function forwardImageHelper(array) {
        if (positionTutorial + 1 <= array.length - 1)
            setPositionTutorial((old) => {
                return old + 1;
            });
        else setPositionTutorial(0);
    }
    function backImageHelper(array) {
        console.log(positionTutorial);
        if (positionTutorial - 1 >= 0)
            setPositionTutorial((old) => {
                return old - 1;
            });
        else setPositionTutorial(array.length - 1);
    }
    function removeScript() {
        const newScriptRemove = document.getElementById("newScript");
        if (newScriptRemove) newScriptRemove.remove();

        const botaoWhatsapp = document.getElementById(
            "bricks-component-QcURrrx4_X5hiXqsNTVXrg-wrapper"
        );
        if (botaoWhatsapp) botaoWhatsapp.remove();
    }

    useEffect(() => {
        carregaDadosPerfil();
        VerificaUserAdmin();
        setInterval(() => {
            removeScript();
        }, 5000);
    }, []);
    //effect para zerar a busca quando sair da pagina de /busca
    useEffect(() => {
        setBusca("");
    }, [location.pathname]);

    async function carregaDadosPerfil() {
        try {
            let dados = await GetCurrentUser();
            localStorage.setItem("currentUser", JSON.stringify(dados));
            setNomePerfil(dados.Name);
        } catch (error) {
            Toastify.error("Erro ao carregar dados de perfil");
            return "";
        }
    }
    async function VerificaUserAdmin() {
        try {
            const data = await IsAdmin();
            setAdmin(data);
        } catch (error) {
            Toastify.error("erro ao verifcar IsAdmin");
        }
    }
    function realizarBusca(event) {
        setBusca(event.target.value);
    }
    function abreBusca(event) {
        if (event.key === "Enter") {
            history.push(`/app/busca/${event.target.value}`, [
                { teste: event.target.value },
            ]);
            // setBuscaOpen(true);
        }
    }
    async function Sair() {
        let verifyLogout = await logout();
        if (verifyLogout.status === 200) {
            window.location.href = "/";
            console.log("saindo");
        } else {
            Toastify.error("Não foi possível realizar");
        }
    }

    function toggleMenu(boolean) {
        if (window.screen.width > 800) {
            let buttonTrial = document.getElementById("buttonTrial");
            if (buttonTrial) {
                if (!boolean) buttonTrial.style.zIndex = -1;
                else buttonTrial.style.zIndex = 11;
            }
            setSubMenuUserIsOpen(!boolean);
            return;
        } else {
            let buttonTrial = document.getElementById("buttonTrial");
            if (buttonTrial) {
                if (!boolean) buttonTrial.style.display = "none";
                else buttonTrial.style.display = "flex";
            }
            setSubMenuUserIsOpen(!boolean);
        }
    }
    function showAgainTrialButton() {
        let buttonTrial = document.getElementById("buttonTrial");
        if (buttonTrial) {
            buttonTrial.style.zIndex = 11;
        }
        setSubMenuUserIsOpen(false);
    }

    return (
        <Container id="menu" flex={"flex"}>
            <ContainerHeader flex={"flex"} style={{ background: "#0594a5" }}>
                <ContainerIconSoftware>
                    <Link to="/app/home">
                        {" "}
                        <img src={logoSocial} />
                    </Link>
                    {/* Input de busca*/}
                    <DivBusca>
                        <IconMdSearch />
                        <Input
                            value={busca}
                            onChange={(event) => {
                                realizarBusca(event);
                            }}
                            onKeyPress={(event) => {
                                abreBusca(event);
                            }}
                            placeholder="Busca"
                            style={{
                                width: "calc((40vw * 45)/100)",
                                fontFamily: "Ubuntu",
                                backgroundColor: window.location.href.includes(
                                    "postedit"
                                )
                                    ? "#f0f2f5"
                                    : "#fff"
                            }}
                            disabled={
                                window.location.href.includes("postedit")
                                    ? true
                                    : false
                            }                           
                        />
                    </DivBusca>
                    <Link
                        data-tip
                        data-for="sharePost"
                        to="/app/categoria/Mais Compartilhados"
                    >
                        <ContainerBtnsHeadSide>
                            <IconMdShare />
                        </ContainerBtnsHeadSide>
                    </Link>
                    <Link data-tip data-for="editPost" to="/app/myposts">
                        <ContainerBtnsHeadSide
                            mobile={window.screen.width < 800}
                        >
                            <IconMdBorderColor />
                        </ContainerBtnsHeadSide>
                    </Link>
                    {/* <Link
                        data-tip
                        data-for="editWebSite"
                        to="/app/configpagesblog"
                    >
                        <ContainerBtnsHeadSide
                            mobile={window.screen.width < 800}
                        >
                            <IconCgWebsite />
                        </ContainerBtnsHeadSide>
                    </Link> */}
                    {/* <Link data-tip data-for="previewBlog" to='/previewinicio'>
                        <ContainerBtnsHeadSide >
                            <IconMdLanguage />
                        </ContainerBtnsHeadSide>
                    </Link> */}
                </ContainerIconSoftware>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    <ContainerBtnPerfilConfig
                        onClick={() => toggleMenu(subMenuUserIsOpen)}
                        subMenuUserIsOpen={subMenuUserIsOpen}
                    >
                        <span style={{ fontFamily: "Ubuntu" }}>
                            {nomePerfil}
                        </span>
                        <IconMdArrowDropDown />
                        <SubMenu
                            style={{ zIndex: "100000" }}
                            subMenuUserIsOpen={subMenuUserIsOpen}
                            onMouseLeave={showAgainTrialButton}
                        >
                            <ul>
                                <Link to="/app/profile">
                                    <SubMenuLi>
                                        <MdPerson />
                                        <span>Meu Perfil</span>
                                    </SubMenuLi>
                                </Link>
                                <MeusPosts>
                                    <Link to="/app/myposts">
                                        <SubMenuLi>
                                            <IconMdAssignment />
                                            <span>Meus Posts</span>
                                        </SubMenuLi>
                                    </Link>
                                </MeusPosts>
                                {/* <Link to='/app/tutoriais'>
                                    <SubMenuLi>
                                        <IconIoMdHelpCircle />
                                        <span>Tutoriais</span>
                                    </SubMenuLi>
                                </Link> */}
                                {/* <Link to='#'>
                                    <SubMenuLi>
                                        <IconMdVpnKey />
                                        <span>Trocar Senha</span>
                                    </SubMenuLi>
                                </Link> */}
                                {admin ? (
                                    <>
                                        <Link to="/app/adminclientes">
                                            <SubMenuLi>
                                                <IconMdPeople />
                                                <span>Lista de Clientes</span>
                                            </SubMenuLi>
                                        </Link>
                                        <Link to="/app/newtemplate">
                                            <SubMenuLi>
                                                <IconMdAddBox />
                                                <span>Novo Post Template</span>
                                            </SubMenuLi>
                                        </Link>
                                        <Link to="/app/allpostunblockeds">
                                            <SubMenuLi>
                                                <IconMdAddBox />
                                                <span>
                                                    Todos Posts Template
                                                </span>
                                            </SubMenuLi>
                                        </Link>
                                    </>
                                ) : (
                                    ""
                                )}
                                {window.screen.width < 800 ? (
                                    <>
                                        <SubMenuLi>
                                            <span>?</span>
                                            <span>Tutoriais</span>
                                        </SubMenuLi>
                                        <Link to="/app/configpagesblog">
                                            <SubMenuLi>
                                                <IconCgWebsite />
                                                <span>Criar site</span>
                                            </SubMenuLi>
                                        </Link>
                                    </>
                                ) : (
                                    ""
                                )}
                                <SubMenuLi
                                    onClick={() => {
                                        Sair();
                                    }}
                                >
                                    <MdExitToApp />
                                    <span>Sair</span>
                                </SubMenuLi>
                            </ul>
                        </SubMenu>
                    </ContainerBtnPerfilConfig>
                    {/*Icone de notificação ativar quando tiver o sistema de notificação*/}
                    <ContainerBtnsHeadSide style={{ display: "none" }}>
                        <IconMdNotifications />
                    </ContainerBtnsHeadSide>
                    {window.screen.width > 800 ? (
                        <ContainerBtnsHeadSide
                            onClick={() => openPopupHelper()}
                        >
                            <span>?</span>
                        </ContainerBtnsHeadSide>
                    ) : (
                        ""
                    )}
                </div>
            </ContainerHeader>
            <Tooltip
                dataFor="previewBlog"
                mensagem="Pre-visualização do blog"
            />
            <Tooltip dataFor="editPost" mensagem="Editar seus posts" />
            <Tooltip
                dataFor="sharePost"
                mensagem="Visualizar os posts mais compartilhados"
            />
            <Tooltip
                dataFor="editWebSite"
                mensagem="Edite o seu site que será criado"
            />
            <Popup
                open={popupTutorial}
                onClose={closePopupHelper}
                contentStyle={{ width: "unset" }}
            >
                <div
                    style={{
                        width: "90vw",
                        height: "90vh",
                        display: "flex",
                        flexDirection: "column",
                        userSelect: "none",
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <h1 style={{ margin: "0 0 20px 0" }}>
                        Ajuda Contextual {positionTutorial + 1}/
                        {contentTutorial.length}{" "}
                    </h1>
                    <ImgHelper src={contentTutorial[positionTutorial]} alt="" />
                    <IconIoIosArrowForward
                        onClick={() => forwardImageHelper(contentTutorial)}
                    />
                    <IconIoIosArrowBack
                        onClick={() => backImageHelper(contentTutorial)}
                    />
                </div>
            </Popup>
        </Container>
    );
};

export default Menu;
